import { useState, useCallback } from 'react';

// Custom hook for managing flash messages (error/success notifications)
export const useFlashMessage = () => {
  const [message, setMessage] = useState('');
  const [type, setType] = useState('error'); // 'error', 'success', or 'warning'
  const [isVisible, setIsVisible] = useState(false);

  const showMessage = useCallback((text, messageType = 'error', autoHide = true) => {
    setMessage(text);
    setType(messageType);
    setIsVisible(true);
    
    // Auto-hide after 5 seconds only if autoHide is true
    // Configuration warnings should not auto-hide
    if (autoHide && messageType !== 'warning') {
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    }
  }, []);

  const showError = useCallback((text) => {
    showMessage(text, 'error', true);
  }, [showMessage]);

  const showSuccess = useCallback((text) => {
    showMessage(text, 'success', true);
  }, [showMessage]);

  const showWarning = useCallback((text) => {
    showMessage(text, 'warning', false); // Warnings don't auto-hide
  }, [showMessage]);

  const hideMessage = useCallback(() => {
    setIsVisible(false);
  }, []);

  return {
    message,
    type,
    isVisible,
    showMessage,
    showError,
    showSuccess,
    showWarning,
    hideMessage,
  };
};

export default useFlashMessage;